/*
 * Add New Address Button Component
 * Reusable button for adding new addresses (shipping/billing)
 */
import React from 'react'
import PropTypes from 'prop-types'
import Button from '/overrides/app/components/button'

const AddNewAddressButton = ({onClick, children}) => {
    return (
        <Button
            variant="outline"
            border="1px dashed"
            borderColor="gray.300"
            color="blue"
            height={['44px', '44px', '118px']}
            fontWeight="normal"
            fontSize="lg"
            onClick={onClick}
            alignSelf="center"
        >
            {children}
        </Button>
    )
}

AddNewAddressButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node
}

export default AddNewAddressButton
